import { render, staticRenderFns } from "./TranslationsView.vue?vue&type=template&id=7dff1154&"
import script from "./TranslationsView.vue?vue&type=script&lang=ts&"
export * from "./TranslationsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports